import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {ABAC} from "./objects/ABAC";
import {useAuth} from "../useAuth";
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import OgCodeEditor from "./OgCodeEditor";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

const objectsGridAbacUrl = process.env.REACT_APP_OBJECTS_GRID_BASE_URL + '/abacpolicies/abac-policy--';

const ABACPanel = () => {

    const {ogToken, ogAccessPoint, ogOrgId} = useAuth();

    const [showCurlDialog, setShowCurlDialog] = useState(false);

    const [abac, setAbac] = useState<ABAC>();
    const [newPolicy, setNewPolicy] = useState<string | undefined>();

    const toast = useRef(null);

    useEffect(() => {
        fetchAbac();
    }, [])

    const fetchAbac = async () => {

        console.log("Fetch Abac. Using token: ", ogToken);

        return axios.get(objectsGridAbacUrl + ogOrgId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`,
                    '--header': 'Accept: */*'
                }
            }).then(response => {
            console.log('Response from getAbac: ', response.data);
            setAbac(response.data);
        }).catch(error => console.error('Getting abac failed:', error));
    };

    const abacCurlDialogHeader = (options: { className: any; }) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold text-lg">ABAC Policy</span>
                </div>
                <div>
                    <Button
                        icon="pi pi-code"
                        label="Show cURL"
                        onClick={() => setShowCurlDialog(true)}
                    />
                </div>
            </div>
        );
    };

    const curlCommand = `curl -L \\
        --url 'https://testapis.objectsgrid.com/abacpolicies/abac-policy--${ogOrgId}' \\
        --header 'Authorization: Bearer ${ogToken}' \\
        --header 'X-ObjectsGrid-AccessPoint: ${ogAccessPoint}' \\ 
        --header 'Accept: */*'`;

    const accept = () => {
        console.log("User clicked to accept and wants to replace the ABAC policy");

        const updatedAbac = { ...abac, policy: newPolicy };
        console.log("Updated ABAC: ", updatedAbac);

        return axios.put(objectsGridAbacUrl + ogOrgId,
            updatedAbac,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`
                }
            }).then(response => {
                console.log('Response from putAbac: ', response.data);
                // @ts-ignore
                toast.current.show({ severity: 'success', summary: 'Saved', detail: 'New ABAC Policy saved' });
                fetchAbac().then(r => console.log("Refetched ABAC after update: ", r));
        }).catch(error => console.error('Getting abac failed:', error));
    }

    const reject = () => {
        console.log("Clicked reject");
    }

    const saveAbac = () => {
        confirmDialog({
            message: "Are you sure that you want to overwrite the current ABAC policy? ",
            header: 'Replace ABAC policy?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept,
            reject
        });
    }

    return (
        <div>
            <Panel headerTemplate={abacCurlDialogHeader}>
                <div>
                    <Button
                        label="Save ABAC"
                        icon="pi pi-pencil"
                        className="mb-2 mr-2"
                        onClick={() => saveAbac()}
                    />
                    <div>
                        {!abac ? (
                            <div></div>
                        ) :
                            <OgCodeEditor code={abac?.policy}
                                   setCode={(newPolicy) => setNewPolicy(newPolicy)}/>
                        }
                    </div>
                </div>
            </Panel>

            <Dialog
                header="cURL Command"
                visible={showCurlDialog}
                style={{width: '60vw'}}
                onHide={() => setShowCurlDialog(false)}
            >
                <div>
                    <p>You can use this command to get your ABAC policy from a terminal...</p>
                    <pre className="bg-gray-100 p-3 rounded overflow-auto">
                                <code>{curlCommand}</code>
                            </pre>
                    <Button
                        label="Copy to Clipboard"
                        icon="pi pi-copy"
                        onClick={() => navigator.clipboard.writeText(curlCommand)}
                        className="mt-2"
                    />
                </div>
            </Dialog>
            <Toast ref={toast} />
            <ConfirmDialog />
        </div>);

};

export default ABACPanel;
